var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilecircle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3273 21.1795C15.3184 21.8166 16.4981 22.0958 17.6703 21.9708C18.8425 21.8458 19.9365 21.3242 20.7705 20.4925L21.497 19.7672C21.8191 19.442 22 19.003 22 18.5457C22 18.0882 21.8191 17.6494 21.497 17.3242L18.4379 14.2896C18.1154 13.9691 17.6789 13.7891 17.2238 13.7891C16.7688 13.7891 16.3322 13.9691 16.0098 14.2896C15.684 14.6113 15.2443 14.7917 14.7861 14.7917C14.328 14.7917 13.8882 14.6113 13.5625 14.2896L8.68715 9.42269C8.36492 9.09755 8.18417 8.65862 8.18417 8.20121C8.18417 7.74382 8.36492 7.30488 8.68715 6.97972C9.00822 6.65782 9.18847 6.22205 9.18847 5.76777C9.18847 5.31351 9.00822 4.87775 8.68715 4.55583L5.74281 1.50211C5.4171 1.18044 4.9774 1 4.51919 1C4.061 1 3.6213 1.18044 3.29557 1.50211L2.56904 2.22737C1.72094 3.04813 1.18045 4.13441 1.03779 5.30496C0.895135 6.47549 1.15893 7.65946 1.78517 8.65927C5.11901 13.6002 9.37777 17.8516 14.3273 21.1795Z",
    stroke: "#555E61",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilecircle1);
export default __webpack_public_path__ + "static/media/profilecircle-1.20208d2984d61fa7998c1ee988bce1b2.svg";
export { ForwardRef as ReactComponent };